import { TextLink, TextPassage } from '@petsmart-ui/sparky';

import { NAVIGATION_URLS } from '@libs/core';

import { useViewAutoshipOrder } from '../../model/analytics';

export const ViewOrderButton = () => {
    const { send } = useViewAutoshipOrder();

    return (
        <TextLink
            onClick={send}
            href={NAVIGATION_URLS.velocity.account.autoShip}
            className="view-order-button sparky-c-button sparky-c-button--primary add-to-cart-button"
        >
            <TextPassage className="view-order-button__text" size="lg">
                View order
            </TextPassage>
        </TextLink>
    );
};
